var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavJobs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.02 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#FAC00A;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "jobs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1",
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "jobs",
    className: "resources-white.svg",
    d: "M34.21,23.52H10.13a1.82,1.82,0,0,1,0-3.64H34.2a1.82,1.82,0,1,1,0,3.64Zm0-9.7H10.13a1.82,1.82,0,0,1,0-3.64H34.2a1.82,1.82,0,1,1,0,3.64Zm0-9.7H10.13a1.82,1.82,0,0,1,0-3.64H34.2a1.82,1.82,0,1,1,0,3.64ZM2.41,0A2.44,2.44,0,1,1,0,2.47v0A2.42,2.42,0,0,1,2.41,0Zm0,9.56A2.44,2.44,0,1,1,0,12v0A2.42,2.42,0,0,1,2.41,9.56Zm0,9.56A2.44,2.44,0,1,1,0,21.59v0a2.42,2.42,0,0,1,2.41-2.44Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavJobs);
export default __webpack_public_path__ + "static/media/navJobs.ea873dcc.svg";
export { ForwardRef as ReactComponent };